import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { RemindersOverview, RemindersTrendPoint, ReminderTrackerItem, TrackerQueryParams } from '@app/core/api/reminders-analytics';
import { AnalyticsQueryParams, AnalyticsTrendQueryParams } from '@app/core/api/analytics-shared';

export const RemindersAnalyticsActions = createActionGroup({
  source: 'Reminders Analytics',
  events: {
    'Load Overview': props<{ params: AnalyticsQueryParams }>(),
    'Load Overview Success': props<{ overview: RemindersOverview }>(),
    'Load Overview Failure': props<{ error: string }>(),

    'Load Trend': props<{ params: AnalyticsTrendQueryParams }>(),
    'Load Trend Success': props<{ trend: RemindersTrendPoint[] }>(),
    'Load Trend Failure': props<{ error: string }>(),

    'Load Tracker': props<{ params: TrackerQueryParams }>(),
    'Load Tracker Success': props<{ tracker: ReminderTrackerItem[] }>(),
    'Load Tracker Failure': props<{ error: string }>(),

    'Clear Reminders Analytics State': emptyProps(),
  }
});
